import { render } from "./CreateNewProjectPage.vue?vue&type=template&id=df3bb410&ts=true"
import script from "./CreateNewProjectPage.vue?vue&type=script&lang=ts"
export * from "./CreateNewProjectPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__